import React, { useState } from 'react';
import { Button, Card, Form, Input } from 'antd';
import { LockOutlined, MailOutlined, NumberOutlined } from '@ant-design/icons';
import { useLocation, Link } from 'react-router-dom';
import Hero from 'components/Hero';
import useGlobalContext from 'hooks/useGlobalContext';
import useFormatMessage from 'hooks/useFormatMessage';
import messages from './messages';
import useAuth from '../../hooks/useAuth';

const LoginForm = () => {
  const $t = useFormatMessage();
  return (
    <>
      <Form.Item name="email" rules={[{ required: true, message: $t(messages.emailRequired) }]}>
        <Input
          prefix={<MailOutlined className="input-icon" />}
          type="email"
          placeholder={$t(messages.email)}
        />
      </Form.Item>
      <Form.Item name="password" rules={[{ required: true, message: $t(messages.passwordRequired) }]}>
        <Input.Password
          prefix={<LockOutlined className="input-icon" />}
          placeholder={$t(messages.password)}
        />
      </Form.Item>
    </>
  );
};

const MfaForm = () => {
  const $t = useFormatMessage();
  return (
    <Form.Item name="mfaCode" label={$t(messages.mfa)} rules={[{ required: true, len: 6, message: $t(messages.mfaCodeRequired) }]}>
      <Input
        prefix={<NumberOutlined className="input-icon" />}
        placeholder={$t(messages.mfaCode)}
      />
    </Form.Item>
  );
};

const Login = () => {
  const $t = useFormatMessage();
  const [loading, setLoading] = useState(false);
  const [mfa, setMfa] = useState(false);
  const location = useLocation();
  const { login } = useAuth();
  const { modal } = useGlobalContext();
  const [form] = Form.useForm();

  const onSubmit = async () => {
    const values = form.getFieldsValue(true);
    setLoading(true);
    try {
      const res = await login(values.email, values.password, values.mfaCode, location?.state?.referrer);
      if (res?.mfa) {
        setMfa(true);
      }
    } catch (e) {
      modal.error({ content: messages[e.message] ? $t(messages[e.message]) : e.message, centered: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Hero branded>
      <Card>
        <Form onFinish={onSubmit} layout="vertical" form={form} validateTrigger="onSubmit">
          {mfa ? (
            <MfaForm />
          ) : (
            <LoginForm />
          )}
          <Form.Item>
            <Button block type="primary" htmlType="submit" loading={loading}>
              {$t(messages.login)}
            </Button>
          </Form.Item>
          {!mfa && (
            <Link to="/forgot-password">
              {$t(messages.forgotPassword)}
            </Link>
          )}
        </Form>
      </Card>
    </Hero>
  );
};

export default Login;
